<!-- <ng-ui-kit-dropdown
  [items]="dropdownItems$ | async"
  [open]="isDropdownOpen"
  (toggle)="toggleDropdown()"
  (onChange)="onChangeDropdown($event.value)">
  <ng-ui-kit-button
    icon="contact_support"
    [header]="true"
    [stopPropagation]="false"
    (onClick)="toggleDropdown()">
  </ng-ui-kit-button>
</ng-ui-kit-dropdown> -->

<ng-ui-kit-button
  (onClick)="openSupport()"
  icon="contact_support"
  [header]="true"
  [ariaLabel]="'HEADER.CONTACT_SUPPORT.FEEDBACK' | translate">
</ng-ui-kit-button>
